import { useState } from 'react';

import { logo } from '../../Assets/images';

const STORAGE_KEY = 'siteAccess';
const SITE_PASSWORD = process.env.REACT_APP_SITE_PASSWORD;

// Front-end only gate for the main site (pre-launch). It keeps casual visitors out;
// it is not a substitute for server-side protection.
const isUnlocked = () => {
    // No password configured: stay open in development, locked in production.
    if (!SITE_PASSWORD) return process.env.NODE_ENV !== 'production' ? true : false;
    try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
};

export const SiteGate = ({ children }) => {
    const [unlocked, setUnlocked] = useState(isUnlocked);
    const [value, setValue] = useState('');
    const [error, setError] = useState('');

    if (unlocked) return children;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (SITE_PASSWORD && value === SITE_PASSWORD) {
            try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (err) { /* ignore */ }
            setUnlocked(true);
        } else {
            setError('Incorrect password.');
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#f7f7f7' }}>
            <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow-sm text-center" style={{ width: 360, maxWidth: '90%' }}>
                <img src={logo} alt="Kayifi" style={{ maxWidth: 180, marginBottom: 16 }} />
                <h5 className="mb-3">This site is password protected</h5>
                <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Enter password"
                    value={value}
                    onChange={(e) => { setValue(e.target.value); setError(''); }}
                    autoFocus
                />
                {error && <div className="text-danger small mb-2">{error}</div>}
                <button type="submit" className="btn w-100" style={{ background: '#f6a566', color: '#fff' }}>Enter</button>
            </form>
        </div>
    );
};
